import {
  brandEntityId,
  BrandEntityId,
  brandOverlayDataFile,
  BrandOverlayDataFile,
  brandOverlayDataHeight,
  BrandOverlayDataHeight,
  brandOverlayDataWidth,
  BrandOverlayDataWidth,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayCreate2VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayCreate2VO.validationSchema()
  );

  constructor(readonly value: RoomBrandOverlayCreate2) {
    JsonSchemaValidator.assert(RoomBrandOverlayCreate2VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandOverlayDataFile,
        width: brandOverlayDataWidth,
        height: brandOverlayDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayCreate2 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandOverlayDataFile;
  width: BrandOverlayDataWidth;
  height: BrandOverlayDataHeight;
}
